import { cn } from '@/lib/utils';

export type Onglet<T extends string> = {
  valeur: T;
  libelle: string;
  compteur?: number;
};

/** Onglets de filtre — le moutarde marque l'onglet actif. */
export function Tabs<T extends string>({
  onglets,
  actif,
  onChange,
  className,
}: {
  onglets: readonly Onglet<T>[];
  actif: T;
  onChange: (valeur: T) => void;
  className?: string;
}) {
  return (
    <div
      role="tablist"
      className={cn('flex flex-wrap items-center gap-1 border-b border-line', className)}
    >
      {onglets.map((o) => {
        const estActif = o.valeur === actif;
        return (
          <button
            key={o.valeur}
            role="tab"
            type="button"
            aria-selected={estActif}
            onClick={() => onChange(o.valeur)}
            className={cn(
              '-mb-px border-b-2 px-3 py-2 text-sm font-medium transition-colors',
              estActif
                ? 'border-mustard-500 text-ink'
                : 'border-transparent text-ink-muted hover:border-line hover:text-ink',
            )}
          >
            {o.libelle}
            {o.compteur !== undefined ? (
              <span
                className={cn(
                  'ml-1.5 rounded-full px-1.5 py-0.5 text-xs tabular',
                  estActif ? 'bg-mustard-100 text-mustard-800' : 'bg-surface-sunken text-ink-muted',
                )}
              >
                {o.compteur}
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
